import { render, staticRenderFns } from "./MapaComprasPublicas.vue?vue&type=template&id=8dd371b6"
import script from "./MapaComprasPublicas.vue?vue&type=script&lang=js"
export * from "./MapaComprasPublicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports